import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Select, Checkbox, DatePicker, TimePicker, Radio, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import moment from 'moment'
import countryCodes from '../../utils/countryCodes'
import { checkSelectOption, clanicData, errorMessage, successMessage } from '../../utils/helpers'
import { useSelector } from 'react-redux'
import { POST } from '../../utils/apis'
import axios from 'axios'


const { Option } = Select
const DoctorRoomFormComponent = (props) => {
    const { onCancel, edit, user, language, selectedLanguage, userActions, roles } = props
    const myRooms = useSelector(state => state?.userReducer?.allRooms)
    const myServices = useSelector(state => state?.userReducer?.clanicServices)
    const myServicesData = myServices?.length ? myServices : []
    const [laoding, setLoading] = useState(false)
    const [form] = Form.useForm()

    console.log('myRooms', myRooms)

    const onFinish = async (values) => {
        values.clanicId = user?._id
        console.log('values', values)
        setLoading(true)
        if (edit?._id) {
            values._id = edit?._id
            axios.post(POST?.EDIT_ROOM, values)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllRooms(userActions, user?._id)
                        await onCancel()
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        } else {
            axios.post(POST?.ADD_ROOM, values)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllRooms(userActions, user?._id)
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        }
    }

    useEffect(() => {
        clanicData.getMyAllServices(userActions, user?._id)
        clanicData.getMyAllRooms(userActions, user?._id)
    }, [])

    return (
        <div>
            <Form
                name='form'
                onFinish={onFinish}
                layout={'vertical'}
                form={form}
            >
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name={"roomName"}
                            label={selectedLanguage?.txt_room_name}
                            initialValue={edit?.roomName}
                        >
                            <Input
                                className='form-input-new-style' placeholder={selectedLanguage?.txt_enter_room_name} />
                        </Form.Item>
                    </div>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name='services'
                            hasFeedback
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_services}</p>}
                            initialValue={edit?.services?.map((v, i) => v?._id)}
                        >
                            <Select
                                mode='multiple'
                                allowClear
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_select_services}
                            >
                                {(myServicesData || [])?.map((v, i) => {
                                    return (
                                        <Option value={v?._id}>{v?.serviceName}</Option>
                                    )
                                })}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {edit?._id &&
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            onClick={onCancel}
                        >
                            {selectedLanguage?.txt_cancel}
                        </Button>}
                    <br />
                    <br />
                    <Form.Item>
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            htmlType='submit'
                            laoding={laoding}
                        >
                            {edit?._id ? selectedLanguage?.txt_update : selectedLanguage?.txt_add}
                        </Button>
                    </Form.Item>
                </div>
            </Form >
        </div>
    )
}

export default DoctorRoomFormComponent